module.exports = __webpack_public_path__ + "static/media/image10.f90945c6.jpg";